export const NEWSLETTER_SOURCES = {
  MARKET_ANALYSIS: 'market-analysis',
  INSIGHTS: 'insights',
  ECONOMIC_CALENDAR: 'economic-calendar',
  MARKET_ANALYSIS_ARTICLE: 'market-analysis-article',
};

export const NEWSLETTER_SOURCE_LABELS = {
  [NEWSLETTER_SOURCES.MARKET_ANALYSIS]: 'Market Analysis',
  [NEWSLETTER_SOURCES.INSIGHTS]: 'Insights',
  [NEWSLETTER_SOURCES.ECONOMIC_CALENDAR]: 'Economic Calendar',
  [NEWSLETTER_SOURCES.MARKET_ANALYSIS_ARTICLE]: 'Market Analysis Article',
};

export const getNewsletterSourceLabel = (source) =>
  NEWSLETTER_SOURCE_LABELS[source] || source || 'Unknown';
